/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-11-18 19:35:59
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-11-26 17:08:44
 */

import Vue from 'vue'
import Vuex from 'vuex'
import VueXAlong from 'vuex-along'

Vue.use(Vuex)
const files = require.context('./module/', true, /\.js$/)
// vuex module
const vueModule = {}
files.keys().forEach(key => {
  vueModule[key.replace(/(^\.\/|\.js$)/g, '')] = files(key).default
})
export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: vueModule,
  plugins: [VueXAlong()]
})
